export class VendastaUser {
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  accountGroupAssociationCount: number;
  notificationsEnabled: boolean;
}
